<template>
    <button-bar v-if="quote.reference" sticky center-buttons-on-mobile>
        <asli-button
            v-if="showBackButton"
            id="quotes-back"
            color="secondary"
            type="button"
            @click="() => emit('goBack')"
        >
            Back
        </asli-button>
        <asli-button
            id="quotes-continue"
            color="primary"
            :type="nextIsSubmit ? 'submit' : 'button'"
            :pulse="recalculateFlag"
            @click="() => emit('goNext')"
        >
            {{ recalculateFlag ? "Recalculate" : continueText }}
        </asli-button>
        <template #button-bar-append>
            <div class="flex flex-col justify-end">
                <p class="font-bold text-center sm:text-right">
                    {{ isMonthly ? "Total Amount Payable" : "Total Payment" }}
                </p>
                <p class="font-extrabold text-section-header text-[40px]">
                    €{{ toCurrency(premium?.toString(), true) }}
                </p>
            </div>
        </template>
    </button-bar>
</template>

<script lang="ts" setup>
import { computed, PropType } from "vue";
import ButtonBar from "../ButtonBar.vue";
import { AsliButton, toCurrency } from "@mbs-npm/anpost-ui";
import { Quote } from "@/stores/risk/types/types";
import appDimensions from "@/hooks/app";

const props = defineProps({
    quote: {
        type: Object as PropType<Quote>,
        required: true
    },
    isMonthly: {
        type: Boolean,
        default: false
    },
    premiums: {
        type: Object as PropType<{ monthly: string | number | null; annual: string | number | null }>,
        required: true
    },
    recalculateFlag: {
        type: Boolean,
        default: false
    },
    showBackButton: {
        type: Boolean,
        default: true
    },
    nextIsSubmit: {
        type: Boolean,
        default: false
    }
});

const continueText = computed(() => {
    return appDimensions.width < 640 ? "Continue" : "Continue to next step";
});

const premium = computed(() => {
    return props.isMonthly ? props.premiums.monthly : props.premiums.annual;
});

const emit = defineEmits<{
    (e: "goBack"): void;
    (e: "goNext"): void;
}>();
</script>
